type Props = {
  svgProps?: React.SVGProps<SVGSVGElement>
  iconColor?: string
}

export const TiktokIcon = ({ iconColor, svgProps }: Props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M19.321 5.562a5.124 5.124 0 0 1-.443-.258 6.228 6.228 0 0 1-1.137-.966c-.849-.971-1.165-1.956-1.282-2.645h.004C16.367 1.091 16.4.5 16.409.5h-4.03v15.583c0 .209 0 .416-.009.62 0 .026-.003.049-.004.076-.001.011-.001.023-.003.035v.008a3.428 3.428 0 0 1-1.725 2.729 3.373 3.373 0 0 1-1.677.445c-1.859 0-3.367-1.517-3.367-3.392 0-1.874 1.508-3.391 3.367-3.391.352 0 .7.054 1.034.162l.005-4.1a7.372 7.372 0 0 0-5.675 1.65 7.736 7.736 0 0 0-1.67 2.048c-.17.288-.823 1.487-.91 3.433-.04 1.103.261 2.246.403 2.718v.01c.089.249.431 1.09.988 1.799a8.17 8.17 0 0 0 1.498 1.488v-.01l.01.01c1.873 1.27 3.951 1.187 3.951 1.187.359-.014 1.56 0 2.926-.647 1.515-.718 2.377-1.787 2.377-1.787a7.346 7.346 0 0 0 1.277-2.123c.345-.879.461-1.934.461-2.354V7.635c.047.028.672.441.672.441s.9.578 2.304.954c1.007.269 2.363.326 2.363.326V5.359c-.475.051-1.44-.099-2.428-.585Z"
        fill={iconColor || '#fff'}
      />
    </svg>
  )
}
